export default {
    'getDuplicatedPropertyDescrs': function getDuplicatedPropertyDescrs(scheds) {
        if (!scheds) {
            return {};
        }
        var seen = {};
        var duplicates = {};
        scheds.forEach(function (item) {
            var descr = item.description;
            if (seen.hasOwnProperty(descr)) {
                duplicates[descr] = 1;
            } else {
                seen[descr] = 1;
            }
        });
        return duplicates;
    },

    'isEmpty': function isEmpty(m) {
        return Object.keys(m).length === 0;
    },

    'notIn': function notIn(v, m) {
        return !m.hasOwnProperty(v);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/ho/config/ScheduledPropertiesExpressionValidation.js
// module id = 1191
// module chunks = 0